var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[(_vm.termType === 1)?_c('during-vote'):_vm._e(),(_vm.termType === 2)?_c('ended-vote'):_vm._e(),(_vm.termType === 3)?_c('result-vote'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }